<template>
  <div class="ambassador" :class="{ 'ambassador_large-photo': type === 'largePhoto' }">
    <div class="ambassador__container">
      <div v-if="title" class="ambassador__title" v-html="title"></div>
      <div class="ambassador__items">
        <div class="items__slider">
          <Slider 
            v-if="type === 'general'"
            :navigationOffset="navigationOffset"
            :paginationOffset="paginationOffset"
            :loop="loop"
          >
            <div 
              v-for="(item, i) in items"
              :key="i"
              class="slide__container"
            >
              <div class="slide__quote" v-html="item.quote"></div>
              <div class="slide__avatar" :style="`background-image: url('${item.avatar}');`"></div>
              <div class="slide__name">
                <a v-if="item.link" :href="item.link" target="_blank" v-html="item.name"></a>
                <span v-else v-html="item.name"></span>
              </div>
              <div v-if="item.taskText" class="slide__tasks">
                <a v-if="item.detailsLink" :href="item.detailsLink" target="_blank" v-html="item.taskText"></a>
                <span v-else v-html="item.taskText"></span>
              </div>
            </div>
          </Slider>
          <Slider 
            v-if="type === 'largePhoto'"
            :navigationOffset="navigationOffset"
            :paginationOffset="paginationOffset"
            :loop="loop"
            :autoHeight="autoHeight"
          >
            <div 
              v-for="(item, i) in items"
              :key="i"
              class="slide__container"
            >
              <div class="slide__avatar" :style="`background-image: url('${isMobile ? item.avatarMobile || '' : item.avatar || ''}');`"></div>
              <div class="slide__text">
                <div class="slide__quote">
                  <span v-html="item.quote"></span>
                </div>
                <div class="slide__name">
                  <span v-html="item.name"></span>
                </div>
                <div v-if="item.taskText" class="slide__tasks">
                  <span v-html="item.taskText"></span>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from '@sc-component-library/slider/src/main';

export default {
  name: 'Ambassador',
  designVersion: '1.1.0',
  components: {
    Slider,
  },
  props: {
    /**
     * Текст заголовка
     */
    title: {
      type: String,
    },
    /**
     * Тип верстки карточек для слайдера: <br/>
     * 'general' - обычный внешний вид с кругой фотографией<br/>
     * 'largePhoto' - внешний вид с большой прямоугольной фотографией
     */
    type: {
      type: String,
      default: 'general',
      validator(value) {
        return ['', 'general', 'largePhoto'].indexOf(value) !== -1;
      },
    },
    /**
     * Массив со свойствами карточек для слайдера: <br/>
     * [{ quote: '', avatar: '', avatarMobile: '', name: '', taskText: '' }, ...]
     */
    items: {
      type: Array,
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    navigationOffset() {
      return { default: '0', md: '72', lg: '72', xl: '84' };
    },
    paginationOffset() {
      return { default: '16', md: '32', lg: '32', xl: '48' };
    },
    loop() {
      return true;
    },
    autoHeight() {
      return true;
    },
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768;
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style lang="scss" scoped>
  @import "./Ambassador";
</style>
